import { render, staticRenderFns } from "./BuildingTimeDivisionChart.vue?vue&type=template&id=456da2d9&scoped=true&"
import script from "./BuildingTimeDivisionChart.vue?vue&type=script&lang=js&"
export * from "./BuildingTimeDivisionChart.vue?vue&type=script&lang=js&"
import style0 from "./BuildingTimeDivisionChart.vue?vue&type=style&index=0&id=456da2d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456da2d9",
  null
  
)

export default component.exports